import { Route, Routes } from 'react-router-dom';

import ProgressionsPage from '@/pages/Progressions';
import OpeningPage from '@/pages/Common/Opening';
import SongbookRoutes from '@/pages/Songbook';
import { useTracking } from '@/core/tracking.ts';

function App() {
  useTracking();

  return (
    <Routes>
      <Route element={<OpeningPage />} path="/" />
      <Route element={<ProgressionsPage />} path="/progressions" />
      <Route element={<SongbookRoutes />} path="/songbook/*" />
    </Routes>
  );
}

export default App;
